/* eslint-disable react/no-this-in-sfc */
import React, { useState } from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { usePerformanceVsBenchmark } from '../../hooks/usePerformanceVsBenchmark';
import { MobileHeader } from '../MobileHeader/MobileHeader';
import { PeriodSelector } from '../PeriodSelector/PeriodSelector';
import { PerformanceVsBenchmarkChartWrapper } from './components/PerformanceVsBenchmarkChartWrapper/PerformanceVsBenchmarkChartWrapper';

interface Props {
  selectedItemName: string;
  updatedAt: string;
}

export const PerformanceVsBenchmarkChart = ({ selectedItemName, updatedAt }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const [selectedDate, setSelectedDate] = useState<string | null>(null);

  const { chartTitle } = usePerformanceVsBenchmark();

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {isEmbeddedMobile && (
        <Box mx="16">
          <MobileHeader
            label={selectedItemName}
            subLabel={selectedDate || `Last updated: ${updatedAt}`}
            isHighlighted={!!selectedDate}
          />
        </Box>
      )}

      {isEmbeddedMobile && (
        <Box px="16" mt="12">
          <PeriodSelector isVerticalLayout />
        </Box>
      )}

      {isEmbeddedMobile && (
        <Box mx="16">
          <Text variant="smallCaps" mt="24">
            {chartTitle}
          </Text>
        </Box>
      )}

      <PerformanceVsBenchmarkChartWrapper setSelectedDate={setSelectedDate} />
    </Box>
  );
};
